import React from "react";
import { useUserContext } from "context/UserContext";
import TablesBK from "layouts/BK/tables";
import TablesSP from "layouts/SP/tables";
import { isBkLikeRole } from "utils/roleUtils";

function Tables() {
  const { role } = useUserContext() || {};
  if (role === "SP") {
    return <TablesSP />;
  }
  if (isBkLikeRole(role)) {
    return <TablesBK />;
  }
  return null;
}

export default Tables;
